(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-in-stock"] && !Shopify.designMode) return;
  try {
    (function () {
    var PATTERNS = { '+34': /^[67]\d{8}$/, '+39': /^3\d{8,9}$/, '+351': /^9\d{8}$/ };

    function clean(prefix, raw) {
      var digits = String(raw || '').replace(/\D/g, '');
      var p = prefix.replace('+', '');
      if (digits.indexOf('00' + p) === 0) digits = digits.slice(p.length + 2);
      else if (digits.indexOf(p) === 0 && digits.length > p.length + 8) digits = digits.slice(p.length);
      return digits;
    }

    function init(box) {
      if (box.dataset.bisReady) return;
      box.dataset.bisReady = '1';
      var form = box.querySelector('form');
      var prefix = form.querySelector('[name="prefix"]');
      var phone = form.querySelector('[name="phone"]');
      var field = form.querySelector('.back-in-stock__field');
      var msg = form.querySelector('.back-in-stock__msg');
      var btn = form.querySelector('button[type="submit"]');
      var done = box.querySelector('[data-bis-done]');

      function choice(kind) {
        var f = form.querySelector('[data-bis-kind="' + kind + '"]');
        if (!f) return '';
        var c = f.querySelector('input:checked');
        return c ? c.value : '';
      }

      form.addEventListener('change', function (e) {
        var f = e.target.closest('[data-bis-kind]');
        if (!f) return;
        f.querySelector('[data-bis-chosen]').textContent = e.target.value || box.dataset.labelAny;
      });

      phone.addEventListener('input', function () {
        field.removeAttribute('data-invalid');
        msg.hidden = true;
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (form.querySelector('[name="website"]').value) return;
        var pre = prefix.value;
        var num = clean(pre, phone.value);
        var re = PATTERNS[pre] || /^\d{8,11}$/;
        if (!re.test(num)) {
          field.setAttribute('data-invalid', '');
          msg.textContent = box.dataset.msgInvalid;
          msg.hidden = false;
          phone.focus();
          return;
        }
        var cap = choice('capacidad');
        var color = choice('color');
        btn.setAttribute('aria-busy', 'true');
        fetch(box.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            phone: pre + num,
            product_id: box.dataset.productId,
            product_handle: box.dataset.productHandle,
            product_title: box.dataset.productTitle,
            product_url: box.dataset.productUrl,
            capacidad: cap,
            color: color,
            locale: box.dataset.locale,
            source: 'web-ficha-agotado',
            consent: true,
            consent_text: form.querySelector('.back-in-stock__consent').textContent.trim()
          })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            var pretty = pre + ' ' + num.replace(/(\d{3})(?=\d)/g, '$1 ');
            var what = [box.dataset.productTitle, cap, color].filter(Boolean).join(' · ');
            done.querySelector('[data-bis-done-text]').textContent = box.dataset.msgSuccess.replace('__PHONE__', pretty).replace('__PRODUCT__', what);
            form.hidden = true;
            done.hidden = false;
          })
          .catch(function () {
            msg.textContent = box.dataset.msgError;
            msg.hidden = false;
          })
          .then(function () {
            btn.removeAttribute('aria-busy');
          });
      });
    }

    function boot() {
      document.querySelectorAll('[data-back-in-stock]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trade-in-cta"] && !Shopify.designMode) return;
  try {
    (function () {
    // Pasa a la tasación la variante que se está mirando.
    function boot() {
      document.querySelectorAll('[data-trade-in-link]').forEach(function (link) {
        if (link.dataset.ticReady) return;
        link.dataset.ticReady = '1';
        link.addEventListener('click', function () {
          var v = new URLSearchParams(location.search).get('variant');
          if (v && link.href.indexOf('&variante=') === -1) link.href += '&variante=' + encodeURIComponent(v);
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
